import { sumBy } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import { APP_MOBILE_LAYOUT } from '@/store/modules/app';
import { isMarketDisabled, contractOwnershipNum } from '@/utils/helpers';
import marketContractsListHeaderSushiItem2 from '../market-contracts-list-header-sushi-item2/market-contracts-list-header-sushi-item2.vue';
import marketSettingsButton from '../market-settings-button/market-settings-button.vue';
import marketSettingsModal from '../market-settings-modal/market-settings-modal.vue';

const firstNonEmptyString = (...values) =>
  values.find((value) => typeof value === 'string' && value.trim() !== '');

export default {
  components: {
    marketSettingsButton,
    marketSettingsModal,
    marketContractsListHeaderSushiItem2,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    forCmsWidget: {
      type: Boolean,
      default: false,
    },
    dashboardMode: {
      type: Boolean,
      default: false,
    },
    forceMobileLayout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSettingsModal: false,
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', ['isTradingEnabled', 'isLayoutMobile']),
    ...mapState('app', ['settingShowOdds', 'settingMobileLayout']),
    useMobileLayout() {
      return this.forceMobileLayout || this.isLayoutMobile;
    },
    isCondensedMobileLayout() {
      return this.settingMobileLayout === APP_MOBILE_LAYOUT.CONDENSED;
    },
    mobileBarClassModifiers() {
      return {
        'market-contracts-list-header-sushi__mobile-bar': true,
        'market-contracts-list-header-sushi__mobile-bar--condensed': this.isCondensedMobileLayout,
      };
    },
    hasOwnership() {
      if (this.market === null || !this.isLoggedIn) return false;
      return sumBy(this.market.contracts, (i) => contractOwnershipNum(i)) > 0;
    },
    isMarketDisabled() {
      return this.market !== null && isMarketDisabled(this.market, this.$store);
    },
    pricesTitle() {
      return this.isLayoutMobile ? 'Trade Prices' : 'Last Trade Price';
    },
    titleSecond() {
      if (this.forCmsWidget) {
        return this.settingShowOdds ? 'Odds' : this.pricesTitle;
      }
      if (this.dashboardMode) {
        return this.settingShowOdds ? 'Last Odds' : 'Last Price';
      }
      return 'Latest';
    },
    titleType() {
      return 'Type';
    },
    titleFirst() {
      if (!this.forCmsWidget) {
        return 'Contract';
      }

      return (
        firstNonEmptyString(
          this.market && this.market.marketShortName,
          this.market && this.market.marketName,
        ) || 'Contract'
      );
    },
    titleThird() {
      return this.forCmsWidget ? 'Volume' : 'Ownership';
    },
    titleFourth() {
      return 'Avg. Paid';
    },
    titleFifth() {
      return 'Orders (Buy/Sell)';
    },
    titleBuyOrders() {
      return 'Buy Orders';
    },
    titleSellOrders() {
      return 'Sell Orders';
    },
    titleSixth() {
      return 'Trade';
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
  },
};
